<script>
export default {
    props: {
        lat: { type: Number, default: null },
        lng: { type: Number, default: null },
        address: { type: String, default: null }
    },
    data(){
        return {
            marker: null,
            position: null,
        };
    },
    mounted(){
        this.marking();
    },
    methods: {
        marking(){
            // 기존 마커 제거
            if(this.marker){
                this.marker.setMap(null);
            }

            // console.log({ ...this.$props });
            // console.log({ ...this.$parent.$data });

            // 위도 & 경도로 마커생성
            if(this.lat && this.lng){
                this.position = new kakao.maps.LatLng(this.lat, this.lng);
                this.marker = new kakao.maps.Marker({ position: this.position });
                this.marker.setMap(this.$parent.map);
                // console.log({ ...this.$data });
            }
            // 주소로 마커생성
            else if(this.address){
                this.$parent.geocoder.addressSearch(this.address, (result, status) => {
                    // 정상적으로 검색이 완료됐으면
                    if (status === kakao.maps.services.Status.OK) {
                        this.position = new kakao.maps.LatLng(result[0].y, result[0].x);
                        this.marker = new kakao.maps.Marker({ position: this.position });
                        this.marker.setMap(this.$parent.map);
                        // console.log({ ...this.$data });
                    }
                });
            }
        }
    },
    watch: {
        address(){
            this.marking();
        },
        lat(){
            this.marking();
        },
        lng(){
            this.marking();
        }
    }
}
</script>